const family = {
  bold: 'nitti-bold',
  medium: 'nitti-medium', 
  link: 'underlined',
  primary: 'nitti',
  content: 'typewriter',
  underlined: 'underlined',
  title: 'highlighted'
}

const letter = {
  spacing: {
    default: '-.09em'
  }
}

const size = {
  p4: '1.5rem',
  p3: '1.8rem',
  p2: '2rem',  
  p: '2.2rem',
  h2: '3.8rem',
  h3: '2.8rem',
  h4: '2.4rem'
}

const word = {
  spacing: {
    default: '-.3em'
  }
}

const font = {
  family,
  letter,
  word,
  size
}

export default font